import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as o } from "./index.es277.js";
import "./index.es176.js";
const l = [
  {
    color: o([68, 170, 153]),
    value: "White",
    categoricalLookup: ["white_P"],
    visible: !0
  },
  {
    color: o([177, 70, 70]),
    value: "Asian",
    categoricalLookup: ["Asian_P"],
    visible: !0
  },
  {
    color: o([136, 204, 238]),
    value: "Hispanic or Latino",
    categoricalLookup: ["Hispanic_P"],
    visible: !0
  },
  {
    color: o([221, 204, 119]),
    value: "Black/African American",
    categoricalLookup: ["Afric_P"],
    visible: !0
  },
  {
    color: o([204, 60, 138]),
    value: "American Indian & Alaskan Native",
    categoricalLookup: ["Natives_P"],
    visible: !0
  },
  {
    color: o([17, 119, 51]),
    value: "Native Hawaiian & Other Pacific Islander",
    categoricalLookup: ["Hawaii_P"],
    visible: !0
  },
  {
    color: o([218, 162, 162]),
    value: "Other",
    categoricalLookup: ["Other_P"],
    visible: !0
  },
  {
    color: o([0, 123, 193]),
    value: "Two or More",
    categoricalLookup: ["twoMore_P"],
    visible: !0
  },
  {
    color: "#D6D6D6",
    value: "No Data",
    categoricalLookup: [],
    visible: !0
  }
];
export {
  l as ETHNICITY_BINS
};
//# sourceMappingURL=index.es469.js.map
